import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Form } from "antd";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useAppSelector } from "../../../../../app/store";
import AddIcon from "../../../../../assets/icons/AddIcon";
import {
  TemplateRoles as TemplateRolesType,
  TemplateStepProps,
  TemplateType,
} from "../../../../../types/template.types";
import { TEMPLATE_TYPES } from "../../constants/ticket.constants";
import TemplateRole from "./TemplateRole";

const TemplateRoles = ({ form }: TemplateStepProps) => {
  // Sensors for drag and drop feature
  const sensors = useSensors(useSensor(PointerSensor));

  // Component States
  const [items, setItems] = useState([{ id: uuidv4() }]);
  const [selectedRoles, setSelectedRoles] = useState<TemplateRolesType[]>([]);
  const template = useAppSelector(
    (state) => state?.template.template as TemplateType,
  );
  const templateType = template?.type;

  // Handler function for drug ending
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);

      // Update state to reflect new drag order visually
      const newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);

      // Now move form field too
      form.getFieldInstance("ticket_roles")?.move?.(oldIndex, newIndex); 
    }
  };

  return (
    <div className="mb-6 shadow rounded-lg p-4">
      <DndContext
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        sensors={sensors}
      >
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          <Form form={form} layout="vertical">
            <Form.List name="ticket_roles" initialValue={[{}]}>
              {(fields, { add, remove, move }) => {
                const handleDragEnd = (event: any) => {
                  const { active, over } = event;
                  if (active.id !== over?.id) {
                    const oldIndex = fields.findIndex(
                      (f) => f.key === active.id,
                    );
                    const newIndex = fields.findIndex((f) => f.key === over.id);
                    setItems(arrayMove(items, oldIndex, newIndex));
                    move(oldIndex, newIndex);
                  }
                };

                return (
                  <>
                    <DndContext
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                      sensors={sensors}
                    >
                      <SortableContext
                        items={fields.map((f) => f.key)}
                        strategy={verticalListSortingStrategy}
                      >
                        {fields.map((field, index) => (
                          <TemplateRole
                            selectedRoles={selectedRoles}
                            setSelectedRoles={setSelectedRoles}
                            key={field.key}
                            field={field}
                            remove={remove}
                            form={form}
                            totalFields={fields?.length}
                          />
                        ))}
                      </SortableContext>
                    </DndContext>

                    {!!(templateType !== TEMPLATE_TYPES.sla) && (
                      <div
                        className="text-[#FE7235] gap-2 items-center cursor-pointer inline-flex"
                        onClick={() => {
                          const newItem = { id: uuidv4() };
                          setItems((prev) => [...prev, newItem]);
                          add({});
                        }}
                      >
                        <AddIcon />
                        <span>Add New Field</span>
                      </div>
                    )}
                  </>
                );
              }}
            </Form.List>
          </Form>
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default TemplateRoles;
